import React from "react";
import BreadCrumb from "common/breadcrumb";
import BasicPagination from "./basic-pagination";
import BorderedPagination from "./bordered-pagination";
import SizesPagination from "./sizes-pagination";

const Pagination = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title="Pagination" pageTitle="Navigation" />

                <BasicPagination />
                <BorderedPagination />
                <SizesPagination />
            </div>
        </React.Fragment>
    );
}

export default Pagination;